(function () {
  if (window.partyPlatterCheckoutLoaded) return;
  window.partyPlatterCheckoutLoaded = true;

  function getFields() {
    return {
      wrapper: document.getElementById('PartyPlatterDelivery'),
      date: document.getElementById('PartyPlatterDeliveryDate'),
      time: document.getElementById('PartyPlatterDeliveryTime'),
      error: document.getElementById('PartyPlatterDeliveryError')
    };
  }

  function setMinDate(dateInput) {
    if (!dateInput) return;

    var min = new Date();
    min.setDate(min.getDate() + 3);

    var yyyy = min.getFullYear();
    var mm = String(min.getMonth() + 1).padStart(2, '0');
    var dd = String(min.getDate()).padStart(2, '0');

    dateInput.min = yyyy + '-' + mm + '-' + dd;
  }

  function validatePartyPlatter(showError) {
    var fields = getFields();

    if (!fields.wrapper) return true;

    setMinDate(fields.date);

    var invalid =
      !fields.date ||
      !fields.time ||
      !fields.date.value ||
      !fields.time.value ||
      fields.date.value < fields.date.min;

    if (invalid) {
      if (showError && fields.error) {
        fields.error.classList.remove('hidden');
      }

      if (showError && fields.wrapper) {
        fields.wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }

      return false;
    }

    if (fields.error) {
      fields.error.classList.add('hidden');
    }

    return true;
  }

  function saveAttributesThenCheckout() {
    var fields = getFields();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Party Platter Delivery Date': fields.date ? fields.date.value : '',
          'Party Platter Delivery Time': fields.time ? fields.time.value : ''
        }
      })
    }).finally(function () {
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('change', function (event) {
    if (
      event.target &&
      (
        event.target.id === 'PartyPlatterDeliveryDate' ||
        event.target.id === 'PartyPlatterDeliveryTime'
      )
    ) {
      validatePartyPlatter(false);
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(
      '#checkout-submit, [name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
    );

    if (!trigger) return;

    var fields = getFields();
    if (!fields.wrapper) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!validatePartyPlatter(true)) {
      return false;
    }

    saveAttributesThenCheckout();

    return false;
  }, true);

  document.addEventListener('submit', function (event) {
    var fields = getFields();
    if (!fields.wrapper) return;

    if (!validatePartyPlatter(true)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var fields = getFields();
    setMinDate(fields.date);
  });
})();